import React from 'react';
import PropTypes from 'prop-types';
import Link from './shared/Link';
import fabric from '../../../common/fabric';
import utils from '../../../common/utils';

/**
 * Line component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Line = props => {
  const { params, hyperlink, matrixGroup, globalScale } = props;

  const { shadow } = params;
  const transformMatrix = props.matrixGroup
    ? fabric.util.multiplyTransformMatrices(
        matrixGroup,
        params.ludus.transformMatrix,
      )
    : params.ludus.transformMatrix;

  const object = new fabric.LudusLine(params);

  object.set({
    shadow: null,

    ludus: { ...object.ludus, transformMatrix },
  });

  const svgRendered = `<svg fill="none" class="nonScalingStroke" xmlns="http://www.w3.org/2000/svg">${object.toSVG()}</svg>`;

  const blockStyles = {
    ...props.style,
    left: 0,
    top: 0,
    transformOrigin: 'left top',
    transform: `scale(${globalScale})`,
    mixBlendMode:
      params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : params.globalCompositeOperation,
    filter: shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(shadow, 0, 1)
      : 'none',
  };

  return (
    <Link
      hyperlink={hyperlink}
      style={blockStyles}
      dangerouslySetInnerHTML={{ __html: svgRendered }}
    />
  );
};
Line.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number,
};
Line.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
  globalScale: 1,
};

export default Line;
